import { render } from "./IPDDashboard.vue?vue&type=template&id=5b83f292&scoped=true"
import script from "./IPDDashboard.vue?vue&type=script&lang=js"
export * from "./IPDDashboard.vue?vue&type=script&lang=js"

import "./IPDDashboard.vue?vue&type=style&index=0&id=5b83f292&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b83f292"]])

export default __exports__